// extracted by mini-css-extract-plugin
module.exports = {"swiperContainer":"CardsSwiper_swiperContainer__2Fsae","card":"CardsSwiper_card__FXOJc","active":"CardsSwiper_active__298Jf"};